import { Container } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
//import MecanicosDB from "../../../Components/JsonData/Mecanicos.json"
import { useContext, useEffect, useState } from "react";
import api from "../../../Components/Api/Api";
import Spinner from "../../../Components/Spinner";
import { UserContext } from '../../../context/UserContext';

const AlterarMecanica = () => {
    const navigate = useNavigate(); 
    const location = useLocation();
    const {user} = useContext(UserContext)
    const orcamento = location.state;      
    const [mecanicos, setMecanicos] = useState(['']);
    const [mecanico, setMecanico] = useState('');
    const [status, setstatus] = useState('');
    const [ShowLoading, setShowLoading] = useState(false) 
    const [cadok, setCadok] = useState(false)
    const [atualizar, setAtualizar] = useState(false) 
    const [orcamentos, setOrcamentos] = useState([])
    const credentials = btoa(`${user.userRest}:${user.passRest}`); 
    const headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        "User-Agent": "PneusBrasil",
        "Accept": "application/json",
        'Authorization': `Basic ${credentials}`
    }     
    interface Itens {
        codigo: string;
        nome: string;
      } 
    const [mecan, setMecan] = useState<Itens[]>([]); 
    const buscamecanicos = () => {  
        api.get('Atendentes?tipo=1',{headers})
        .then(response => {  
            if (response.data.Atendentes.length > 0 ){                      
                if (mecan.length < response.data.Atendentes.length){
                    let p_1 = []
                    for (let i = 0; i < response.data.Atendentes.length; i++) {                           
                        p_1.push(response.data.Atendentes[i]['codigo'] + ' ' + response.data.Atendentes[i]['nome']) 
                    } 
                    setMecanicos(p_1) 
                }                                         
            }                                   
        });                
    }    
    useEffect(() => {
        if(mecanicos.length === 1){
            buscamecanicos()
        //     let p_1 = []
        //   for (let i = 0; i <= MecanicosDB.nome.length; i++) {
        //     p_1.push(MecanicosDB.nome[i])
        //   }
        //   setMecanicos(p_1)
        } 
        if(cadok) { 
            navigate('/Oficina')
        } 
        if(!atualizar){
            getos()
          }  
          //console.log(mecanico + ' - ' + status)                  
    })
    function getos () {
        setTimeout(() => {
        setShowLoading(true)
        api.get('Ordemservico?filial='+user.filial+'&Orcamento='+orcamento,{headers})
        .then(response => {
              //console.log(response.data.Entradas)
              if (response.data.Ordens.length > 0 ){   
                  //console.log(response.data.Entradas[0]['Num'])  
                  setOrcamentos(response.data.Ordens)
                  setMecanico(response.data.Ordens[0]['mecanico'])
                  setstatus(response.data.Ordens[0]['status'])
                  setAtualizar(true) 
                  setShowLoading(false)  
                  //console.log(orcamentos)
                  //setInfoveuculo('Placa: ' + placa + ' Modelo: ' + response.data.Dadosveiculo[0]['modelo'] + ' Cor: ' + response.data.Dadosveiculo[0]['cor'])                     
              }else{
                  //setInfoveuculo('Placa não cadastrada!')
                  setShowLoading(false)
                  setAtualizar(true)
              }                                   
        });
      }, 10 );        
      };    
    const chageselectmecanico = (e: any) => {
        if (e.target.value !== '') {
            setMecanico(e.target.value)
        }          
    } 
    const chageselectstatus = (e: any) => {
        if (e.target.value !== '') {
            console.log(e.target.value)
            setstatus(e.target.value)
        }          
    }      
    const updatemecanico = () => {
        setTimeout(() => {
            if (mecanico !== '' && mecanico !== 'Selecione o Mecanico'){
                setShowLoading(true)
                console.log('Orcamento '+orcamento)
                console.log('Mecanico '+mecanico)
                console.log('Status '+status)
                api.get('iniciaServicos?filial='+user.filial+'&Orcamento='+orcamento+'&Mecanico='+mecanico+'&Status='+status,{headers})
                .then(response => {
                      console.log(response.data['info'])
                      console.log(status)
                      if (response.data['info'].length > 0 ){   
                        if(response.data['info'] === 'iniciado'){
                            setShowLoading(false)
                            alert('Ordem de serviço alterada com sucesso!')
                            setCadok(true) 
                        }  
                        if(response.data['info'] === 'erro'){ 
                            setShowLoading(false)
                            alert('Problema na altaração da ordem de serviço, tente novamente!')               
                        }
                          setShowLoading(false)  
                          //setInfoveuculo('Placa: ' + placa + ' Modelo: ' + response.data.Dadosveiculo[0]['modelo'] + ' Cor: ' + response.data.Dadosveiculo[0]['cor'])                     
                      }else{
                        alert('Problema de conexão, tente novamente!')   
                        setShowLoading(false)
                      }                                   
                });
            }else{
                alert("Selecione um mecânico!")
            }
          }, 10 ); 
    } 
    return (
        <>
        <Container>
            <div>
                <span className="mt-4 d-flex justify-content-center fs-3 text-primary">Iniciar o serviço {orcamento} Filial: {user.filial}</span>
            </div>
            <div>
                <label>Mecanico Atual:</label>
            </div>
            <div>
                <select onChange={(e) => chageselectmecanico(e)}>
                    <option key={99} value={mecanico}>{mecanico}</option> 
                    {mecanicos.map((i: any, k: any) => 
                        <option key={k} value={mecanicos[k]}>{mecanicos[k]}</option> 
                    )}
                </select>                
            </div>
            <div>
                <label>Status Atual:</label>                
            </div>
            <div>
                <select onChange={(e) => chageselectstatus(e)} onBlur={(e) =>{setstatus(e.target.value)}}>
                    <option key={99} value={status}>{status}</option> 
                    <option key={1} value='1'>Aberto</option> 
                    <option key={2} value='5'>Mecanica Finalizada</option> 
                    <option key={3} value='91'>Pausar OS</option> 
                    {/* {mecanicos.map((i: any, k: any) => 
                        <option key={k} value={mecanicos[k]}>{mecanicos[k]}</option> 
                    )} */}
                </select>                
            </div>            
            <div className="mt-4">
                <button className="me-4" onClick={updatemecanico}>Salvar</button>
                <button><Link to='/Oficina'>Voltar</Link></button>
            </div>
        </Container>
        <Spinner isLoading={ShowLoading} /> 
        </>
    )
}

export default AlterarMecanica;